import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Form, Formik } from "formik";
import { Toast } from "../../CustomComponent/toast";
import performRequest from "../../api/request";
import CustomInput from "../../CustomComponent/custom_input";
import FormSubmitButton from "../../Components/layouts/formSubmitButton";
import SimpleButton from "../../Components/layouts/simple_button";
import Footer from "../../Components/Footer/footer";
import LoadingPage from "../../Components/layouts/loading";
import { FarmTrainingMediaInfo } from "../../SchemaInfo/info";
import { CreateFarmTrainingMediaSchema } from "../../Schemas/Farm Training Media/create_farmTrainingMedia";
import { BsPatchPlus } from "react-icons/bs";
import { FcMultipleCameras } from "react-icons/fc";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import { useSelector } from "react-redux";
import StepRoutes from "../../Routes/steps_routes";

const AddFarmTrainingMedia = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  let userData = useSelector((store) => store.login.user);

  const handleSubmit = (values, actions) => {
    let formData = new FormData();
    for (let key in values) {
      if (key === "uploadImage") {
        values.uploadImage.forEach((file) => {
          formData.append("uploadImage", file);
        });
      } else {
        formData.append(key, values[key]);
      }
    }
    // const headers = { "Content-Type": "multipart/form-data" };
    setLoading(true);
    performRequest("POST", "/farmMedia/farmTrainingMedia/", formData)
      .then((res) => {
        if (res.status === 200) {
          Toast("success", "Farm media created successfully!");
          navigate(`/view-farmTraining-media`);
        } else {
          Toast("error", "Error while Creating");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xxl">
          <div className="page-header d-print-none">
            <div className="row align-items-center">
              <div className="col-md-8">
                <h2 className="page-title mb-1">
                  <FcMultipleCameras className="fs-2  me-1" /> Add New Farm
                  Training Media
                </h2>
                {/* <h4 className="text-muted">Allot & create new tasks.</h4> */}
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
              <div className="col-md-4">
                <div className="btn-list justify-content-end">
                  {(userData?.Role === process.env.REACT_APP_ROLE_ADMIN_S ||
                    userData?.Role === process.env.REACT_APP_ROLE_ADMIN) && (
                    <a href={"/task-management"}>
                      <button className="btn btn-primary">
                        <BsPatchPlus className="me-2 fs-2" /> View Media List
                      </button>
                    </a>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-3 col-sm-12 py-2">
              <div className="card p-3">
                <p>
                  Only Super Admins and Admins can upload farm training media.
                </p>
                {/* <p>
                  You can not allot tasks to clients or someone out of the
                  organization.
                </p> */}
              </div>
            </div>
            <div className="col-md-9 col-sm-12 py-2">
              <div className="card">
                <Formik
                  initialValues={FarmTrainingMediaInfo}
                  validationSchema={CreateFarmTrainingMediaSchema}
                  onSubmit={handleSubmit}
                >
                  {(props) => (
                    <Form>
                      <div className="card-body">
                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3 required">
                            Training Date
                          </label>
                          <div className="w-100 col">
                            <input
                              type="date"
                              className="form-control"
                              name="trainingDate"
                              value={props.values.trainingDate}
                              onChange={(e) =>
                                props.setFieldValue(
                                  "trainingDate",
                                  e.target.value
                                )
                              }
                            />
                            {props.touched.trainingDate &&
                              props.errors.trainingDate && (
                                <p className="text-danger">
                                  {props.errors.trainingDate}
                                </p>
                              )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label  col-3">
                            Farm Training Media
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="uploadImage"
                              type="file"
                              multiple
                              onChange={(e) =>
                                props.setFieldValue(
                                  "uploadImage",
                                  Array.from(e.target.files)
                                )
                              }
                            />
                            {props.touched.uploadImage &&
                              props.errors.uploadImage && (
                                <p className="text-danger">
                                  {props.errors.uploadImage}
                                </p>
                              )}
                          </div>
                        </div>
                      </div>
                      <div className="card-footer">
                        <div className="btn-list justify-content-end">
                          <FormSubmitButton buttonText="Create Media" />
                          <SimpleButton buttonText="Cancel" type="secondary" />
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default AddFarmTrainingMedia;
